import { createApp } from 'vue'
import App from './App.vue'
import Vuex from 'vuex';
import Axios from 'axios';
import './registerServiceWorker'
import router from './router'
import store from './store'
import FooterMenu from "@/components/FooterMenu";
import BackButton from "@/components/BackButton.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import moment from 'moment';
import registerPushWorker from './registerServiceWorker';

registerPushWorker();

window.deferredPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.deferredPrompt = e;
  // Dispatch a custom event to notify components if they are already mounted
  window.dispatchEvent(new CustomEvent('pwa-install-prompt-available', { detail: e }));
});

// set auth header
Axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.token}`;

createApp(App).use(store).use(router).use(Vuex).use(moment).component('FooterMenu', FooterMenu).component('BackButton', BackButton).component('LoadingSpinner', LoadingSpinner).mount('#app')
